import React, {useEffect, useState} from 'react'
import Page from 'components/Page/Page'
import {Box, Typography, Avatar, Button} from '@mui/material'
import useResponsive from 'logic/useResponsive'
import {
    useGetCurrentUserQuery,
    useGetUserQuery,
    useUpdateProfileMutation,
    useUploadImageMutation,
} from 'store/Store'
import {signupFieldSection} from 'constants/FormField/signupField'
import FormSection from 'components/Control/Form/FormSection'
import {useForm} from 'react-hook-form'
import Loader from 'components/Display/Loader/Loader'
import {onSubmit} from 'services/utils/toastUtils'
import {useTranslation} from 'react-i18next'

const MyProfile = () => {
    const {t} = useTranslation()
    const {smallScreen} = useResponsive()
    const {data: userToken} = useGetCurrentUserQuery()
    const {_id} = userToken || {}
    const {data: user, isLoading} = useGetUserQuery(userToken?._id, {skip: !_id})
    const [doUpdateProfile] = useUpdateProfileMutation()
    const [doUploadImage] = useUploadImageMutation()
    const [imageUrl, setImageUrl] = useState(user?.profileImage || '/images/avatar-placeholder.png')

    const methods = useForm({
        defaultValues: user,
    })

    const {reset, handleSubmit, setValue} = methods

    const submitEdit = handleSubmit((itemData) =>
        onSubmit({itemData, itemName: 'user', doSomething: doUpdateProfile, commandType: 'edit', t})
    )
    useEffect(() => {
        if (user) {
            reset(user)
            setImageUrl(user.profileImage || '/images/avatar-placeholder.png')
        }
    }, [user, reset])

    const handleImageUpload = async (event) => {
        const file = event.target.files[0]
        if (!file) return
        const bodyForm = new FormData()

        bodyForm.append('files', file)
        try {
            const result = await doUploadImage(bodyForm).unwrap()

            if (result.files && result.files.length > 0) {
                const uploadedImageUrl = result.files[0].fullLink
                setImageUrl(uploadedImageUrl)
                setValue('profileImage', result.files[0]?.link)
            }
        } catch (error) {
            console.error('Image upload failed:', error)
        }
    }

    if (isLoading || !user) {
        return <Loader show={true} />
    }

    return (
        <Page>
            {!isLoading && (
                <Box
                    sx={{
                        maxWidth: smallScreen ? '100%' : 800,
                        margin: '0 auto',
                        padding: smallScreen ? 2 : 3,
                    }}>
                    <Typography
                        variant={smallScreen ? 'h5' : 'h4'}
                        gutterBottom
                        textAlign={smallScreen ? 'center' : 'left'}>
                        {t('profile.title')}
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: smallScreen ? 'column' : 'row',
                            alignItems: 'center',
                            marginBottom: 4,
                        }}>
                        <Avatar
                            alt="User Avatar"
                            src={imageUrl}
                            sx={{
                                width: smallScreen ? 60 : 80,
                                height: smallScreen ? 60 : 80,
                                marginBottom: smallScreen ? 2 : 0,
                                marginRight: smallScreen ? 0 : 3,
                            }}
                        />
                        <Button variant="outlined" component="label">
                            {t('profile.image')}
                            <input
                                hidden
                                type="file"
                                accept=".jpg,.jpeg,.png,.svg"
                                onChange={handleImageUpload}
                            />
                        </Button>
                    </Box>
                    <FormSection
                        fields={signupFieldSection}
                        methods={methods}
                        i18nCategory={'signup'}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: smallScreen ? 'center' : 'flex-end',
                            marginTop: 4,
                        }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit(submitEdit)}>
                            {t('profile.saveChanges')}
                        </Button>
                    </Box>
                </Box>
            )}
        </Page>
    )
}

export default MyProfile
